module.exports = __webpack_public_path__ + "static/img/global_internships.1b6d431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_internships.png
// module id = JKcK
// module chunks = 10